import React from 'react';
import { Card, Col, Image, Row } from "react-bootstrap"

import userDefault from '../../img/userdefault.png'
import '../../styles/doctores/CardDoctor.css'

function CardDoctor({doctorInfo}){
    let data = doctorInfo?.doctor
    let especialidad = doctorInfo?.especialty

    return(<>
        <Card className="shadow-1 formSection">
            <Card.Body>
                <Row>
                    <Col xs="12" sm="6" md="4" lg="3" xl="3" className='foto-container'>
                        <Image className='doctor-foto'
                            src={data?.image?.url ?? userDefault} 
                            rounded 
                        />
                    </Col>
                    <Col xs="12" sm="6" md="8" lg="3" xl="4" className='info-doctor'>
                        <span>Nombre: </span>{`${data?.name ?? ''} ${data?.lastName ?? ''}`}<br/>
                        <span>Especialidad: </span>{especialidad?.name ?? ''}
                    </Col>
                    <Col xs="12" sm="12" md="12" lg="6" xl="5" className='horarios-doctor'>
                        <span>Nombre: </span>{`${data?.name ?? ''} ${data?.lastName ?? ''}`}<br/>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    </>)
}

export default CardDoctor